/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

type Props = {
  missingDataSources: Array<string>;
};

function MissingDataSourceError({ missingDataSources }: Props) {
  return (
    <div css={{ backgroundColor: 'var(--cds-color-red-600)', color: 'var(--cds-color-white-0)', padding: '8px 16px' }}>
      <h4>Missing Data Sources</h4>
      <p>The following data sources are missing:</p>
      <ul>
        {missingDataSources.map((dataSource) => (
          <li key={dataSource}>{dataSource}</li>
        ))}
      </ul>
    </div>
  );
}

export default MissingDataSourceError;
